import {type FC} from 'react'

import {getTimeAgo} from 'utils'

export type LastScanLabelProps = {
  lastSyncDateTime: string
  scannedLabel: string
  tooltipLabel: string
  tooltipId?: string
  dataCy?: string
}

export const LastScanLabel: FC<LastScanLabelProps> = ({
  lastSyncDateTime,
  scannedLabel,
  tooltipLabel,
  tooltipId = 'last-scan-tooltip',
  dataCy = 'last-scan-label',
}) => {
  const scannedAgo = getTimeAgo(lastSyncDateTime)

  return (
    <span
      className="karla text-11px text-gray-600 whitespace-nowrap cursor-help"
      data-cy={dataCy}
      data-tooltip-id={tooltipId}
      data-tooltip-content={tooltipLabel}
      data-tooltip-place="bottom"
      aria-label={`${scannedLabel} ${scannedAgo}. ${tooltipLabel}`}
    >
      {`${scannedLabel} `}
      <span className="text-gray-500">{scannedAgo}</span>
    </span>
  )
}
